export default {
  project_name: 'book',
  client: 'building',
  business_unit: 'building',
  c_mi_number: 'hashtag',
  pace_number: 'hashtag',
  division: 'id-badge',
  product_area: 'briefcase',
  product_type: 'tag',
  category: 'bookmark',
  region: 'globe-europe',
  lead_country: 'globe-europe',
  country: 'globe-europe',
  research_type: 'flask',
  methodology: 'clipboard-list',
  design_method: 'pencil-ruler',
  cmi_tool_type: 'tools',
  gender: 'users',
  age: 'users',
  social_class: 'users',
  panel_profile: 'users',
  stage: 'layer-group',
  study_sample_size: 'users',
  number_of_products: 'hashtag',
  base: 'hashtag',
  objective_and_action_standards: 'clipboard-check'
}
